export enum MicrositeItemActionType {
  CHURCH_CENTER = 'CHURCH_CENTER',
  FILE = 'FILE',
  KEYWORD = 'KEYWORD',
  NOTE = 'NOTE',
  PLANNING_CENTER_FORM = 'PLANNING_CENTER_FORM',
  VIDEO = 'VIDEO',
  WEBSITE = 'WEBSITE',
}
